import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  discardImportedDraft,
  getReadyToReview,
  publishImportedDraft,
} from "@/services/importsService";

export const IMPORT_REVIEW_QUERY_KEY = ["importReview"];

export const useImportReview = () =>
  useQuery({ queryKey: IMPORT_REVIEW_QUERY_KEY, queryFn: getReadyToReview });

export const usePublishImportedDraft = (options = {}) =>
  useMutation({
    mutationFn: ({ wantAdId, agreement }) =>
      publishImportedDraft(wantAdId, agreement),
    ...options,
  });

export const useDiscardImportedDraft = (options = {}) =>
  useMutation({
    mutationFn: (wantAdId) => discardImportedDraft(wantAdId),
    ...options,
  });

export const useRefreshImportedData = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: IMPORT_REVIEW_QUERY_KEY });
    queryClient.invalidateQueries({ queryKey: ["agentInventory"] });
    queryClient.invalidateQueries({ queryKey: ["agentClients"] });
  };
};
